const ALLOWED_PROTOCOLS = new Set(['http:', 'https:'])

export function getParameter(param) {
    var url = window.location.search.substring(1),
        paramValues = url.split('&'),
        paramName,
        i

    for (i = 0; i < paramValues.length; i++) {
        paramName = paramValues[i].split('=')

        if (paramName[0] === param && param === 'q') {
            return paramName[1] === undefined
                ? true
                : decodeURIComponent(paramName[1].replace(/\+/g, ' '))
        }
        if (paramName[0] === param) {
            return paramName[1] === undefined
                ? true
                : decodeURIComponent(paramName[1])
        }
    }

    return ''
}

export function getURLParameter(urlSearch) {
    return new URLSearchParams(urlSearch)
}

export function getDocumentURLParameter(urlSearchObj) {
    var redirectUrl = urlSearchObj.get('redirectUrl')
    if(urlSearchObj.has('redirectUrl')) {
        for(const key of urlSearchObj.keys()) {
            if(key != 'redirectUrl') {
                redirectUrl += '&' + key + '=' + urlSearchObj.get(key)
            }
        }
    }
    return redirectUrl
}

export function urlBelongsToApprovedDomains(redirectUrl, domains) {
    //extract the domain name from the redirect URL
    var extractedDomainName = extractDomainName(redirectUrl)
    //if domain matches approved list , return true
    for (var i = 0; i < domains.length; i++) {
        var approveddomain = domains[i]
        // Check for exact match or subdomain match
        if (extractedDomainName === approveddomain || 
            extractedDomainName.endsWith('.' + approveddomain)) {
            return true
        }
    }
    return false
}

export function extractDomainName(url) {
    var domainname
    //find & remove protocol (http, ftp, etc.) and get hostname

    if (url.indexOf('//') > -1) {
        domainname = url.split('/')[2]
    } else {
        domainname = url.split('/')[0]
    }
    //find & remove port number
    domainname = domainname.split(':')[0]
    //find & remove "?"
    domainname = domainname.split('?')[0]

    //remove www
    domainname = domainname.replace('www.', '').replace('www-' , '');
    return domainname
}

export function documentViewerRedirect(redirectUrl, domains) {
    let fallback = window.location.origin
    let safeURL = getSafeRedirectURL(redirectUrl, domains, fallback)
    window.location.href = safeURL
}

function stripControlChars(s) {
    return (s || '').replace(/[\u0000-\u001F\u007F\uFFFD]/g, '').trim()
}

function isDangerousScheme(s) {
    return /^\s*(?:javascript|data|vbscript)\s*:/i.test(s || '')
}

function generateURLObj(candidate, fallbackURL, base = undefined) {
        
    let url
    try {
        url = base ? new URL(candidate, base) : new URL(candidate)
    } catch (e) {
        return fallbackURL
    }
    return url
}

function hostnameIsAllowed(hostname, allowedDomains) {
    let host = (hostname || '').toLowerCase()
    for (let i = 0; i < allowedDomains.length; i++) {
        let domain = (allowedDomains[i] || '').toLowerCase()
        if (host === domain || host.endsWith('.' + domain)) {
            return true
        }
    }
    return false
}

function generateLanguageCodeFromWindow(){
    let locale = 'en-us'
    const localeMatch = window.location.pathname.match(/^\/([a-z]{2}-[a-z]{2})(?:\/|$)/i)
 
    if (localeMatch && localeMatch[1]) {
        locale = localeMatch[1].toLowerCase()
    }
    return locale
}

export function getSafeLocalURL(rawPath) {
    if (!rawPath) {
        return ''
    }

    let candidate = stripControlChars(rawPath)
    candidate = candidate.replace(/\\/g, '/')

    if (isDangerousScheme(candidate) || candidate.startsWith('//')) {
        return ''
    }

    if (/^[a-zA-Z0-9]/.test(candidate) && candidate.indexOf(':') === -1) {
        return new URL('/' + generateLanguageCodeFromWindow() + '/' + candidate, window.location.origin).toString()
    }
    
    let url = generateURLObj(candidate, '', window.location.origin)

    // must stay on the same origin
    if (url === '' || url.origin !== window.location.origin) {
        return ''
    }

    return url.href
}

export function getSafeRedirectURL(rawRedirectUrl, approvedDomains, fallbackURL) {
    if (!rawRedirectUrl || rawRedirectUrl === 'null') {
        return fallbackURL
    }

    let candidate = rawRedirectUrl

    try {
        candidate = decodeURIComponent(candidate)
    } catch (e) {
        // malformed encoding, just use the raw value
    }

    candidate = (candidate || '').replace(/\\/g, '/')
    candidate = stripControlChars(candidate)

    if (isDangerousScheme(candidate)) {
        return fallbackURL
    }

    // relative paths are fine as long as they're not protocol-relative
    if (candidate.startsWith('/')) {
        if (candidate.startsWith('//')) {
            return fallbackURL
        }
        return new URL(candidate, window.location.origin).toString()
    } else if (/^[a-zA-Z0-9]/.test(candidate) && candidate.indexOf(':') === -1) {
        return new URL('/' + generateLanguageCodeFromWindow() + '/' + candidate, window.location.origin).toString()
    }

    let url = generateURLObj(candidate, fallbackURL)

    if (!ALLOWED_PROTOCOLS.has(url.protocol)
        || url.username 
        || url.password
        || !hostnameIsAllowed(url.hostname, approvedDomains)) {
        return fallbackURL
    }

    return url.toString()
}